import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { provideStore } from '@ngxs/store';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';

import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';

import { AuthState } from '@core/states/auth.state';
import { SettingsState } from '@core/states/settings.state';
import { QuickAccessState } from './features/activities/activities-quick-access/activities-quick-access.state';

import { tokenInterceptor } from '@core/interceptors/token.interceptor';
import { HttpErrorInterceptor } from '@core/interceptors/http-error.interceptor';

import { routes } from './app.routes';
import { ClientQuest } from 'src/theme';

registerLocaleData(localeDe);


export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideClientHydration(),
		provideAnimationsAsync(),
		providePrimeNG({
			theme: {
				preset: ClientQuest
			}
		}),
		provideStore(
			[AuthState, QuickAccessState, SettingsState],
			withNgxsReduxDevtoolsPlugin(),
			withNgxsStoragePlugin({
				keys: [
					'auth',
					'quickAccess',
					'settings'
				]
			})
		),
		provideHttpClient(
			withInterceptors([tokenInterceptor]),
			withInterceptorsFromDi()
		),
		{ provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
		// { provide: HTTP_INTERCEPTORS, useClass: FetchInterceptor, multi: true },
		MessageService,
		importProvidersFrom(ToastModule),
		{ provide: LOCALE_ID, useValue: 'de' }, provideServiceWorker('ngsw-worker.js', {
			enabled: true, // !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000'
		}), provideServiceWorker('ngsw-worker.js', {
			enabled: true, //  !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000'
		})
	]
};
